module.exports = __webpack_public_path__ + "static/media/400285_01.68d36d7c.png";